import {validate as validateUUID} from "uuid";
import _ from "lodash";

export const PLATFORM = {
    TEAMS: 'teams-only',
    TRENDS: 'trends',
    VOTE: 'vote',
}

/**
 * @param entityId {string}
 * @returns {string}
 */
export function getPlatform(entityId) {
    const isTeamsEntity = validateUUID(entityId);
    const isAdminMessage = isAdminMessageView();
    if(isTeamsEntity && isAdminMessage) {
        return PLATFORM.TEAMS;
    } else if (!isTeamsEntity && isAdminMessage) {
        return PLATFORM.TRENDS;
    } else {
        return PLATFORM.VOTE;
    }
}

export function getOrganization(message) {
    return _.get(message, 'organization') || _.get(message, 'msgDataSource.organization');
}

export function isAdminMessageView() {
    return _.toString(_.get(window, 'location.pathname')).includes('/labs/messages/');
}